import store from 'util/data/store';

// This should never be hit because readOnly will always
// be true on request controls; but just in case:
export default function(control, assetId) {
    const properties = store.assets[assetId].properties;
    return <div class="text-control">{properties[control.fieldName] || ''}</div>;
}
